import {h} from 'preact';
import Icon from '@components/common/Icon';
import {classList} from '../index';
import {STORE_URL, LOGIN_URL} from '@util/URLUtils';
import pathOr from 'ramda/src/pathOr';
import {toCurrency} from '@util/NumberUtil';

export const SummaryLoginMessage = () =>
    <div className="flex flex-col mb-8 text-center">
        <p>
            {upi.conf.LOGIN_MSG}
            {' '}
            <a href={LOGIN_URL} className="link-2">Sign in</a>
        </p>
    </div>;

export const SummaryCheckout = () =>
    <div className="mv2">
        <a className="button primary w-full" href={STORE_URL}>
            <Icon.ui name="lock-closed" className="text-xl mr-2"/>
            Checkout
        </a>
        <a href={STORE_URL} className="link-2 block text-center my-2 text-xs">Review Cart</a>
    </div>;

export const SummarySubtotal = ( {isUpdating, subtotal} ) => {
    const parsedSubtotal = Math.max( 0, parseFloat( subtotal, 10 ) );

    return (
        <div data-testid="cart-summary-subtotal" className="flex w-full clearfix items-end h-8 mb-8 h-6 font-bold">
            <span className="flex-shrink text-left"
                  data-tooltip="Subtotal is estimated, your final price will be applied at checkout">
                *Subtotal:
            </span>
            {isUpdating || isNaN( parsedSubtotal )
                ?
                <span className="flex-1 text-right text-lg font-normal loading">pending...</span>
                :
                <span data-sx-cart-subtotal
                      className="flex-1 text-right text-xl">${toCurrency( parsedSubtotal )}</span>
            }
        </div>
    );
};

const Summary = ( {cart = {}}, context ) => {
    const {lineItems = [], subtotal = null} = cart;
    const {isUpdating} = context;
    const IS_LOGGED = pathOr( false, ['user', 'isLogged'], context );

    return (
        <div data-testid="cart-summary" className={classList.sectionBlock} style={{minHeight: 176}}>
            <div className="p-4 flex-1 bg-near-white">
                {!IS_LOGGED
                    ? <SummaryLoginMessage/>
                    : <SummarySubtotal subtotal={subtotal} isUpdating={isUpdating}/>
                }
                {lineItems.length > 0 && <SummaryCheckout/>}
            </div>
        </div>
    );
};

export default Summary;
